export { default } from "./Icon.mjs";
export { default as iconClasses } from "./iconClasses.mjs";
export * from "./iconClasses.mjs";